'use client';

import { useLocale } from 'next-intl';
import { useEffect } from 'react';
import { captureAttribution } from '@/lib/analytics/attribution';
import { gtmDataLayerAdapter } from '@/lib/analytics/gtm-data-layer-adapter';
import {
  useAnalyticsPageView,
  useFlushAttributionOnSession,
  useIdentifyUser,
  useLinkClickTracking,
  useScrollDepthTracking,
  useWebVisitorId,
} from '@/lib/analytics/hooks';
import { useIdleMount } from '@/lib/use-idle-mount';

function MountedAnalytics(): null {
  const locale = useLocale();

  useAnalyticsPageView();
  useScrollDepthTracking();
  useLinkClickTracking();
  useFlushAttributionOnSession();
  useWebVisitorId();
  useIdentifyUser();

  useEffect(() => {
    captureAttribution();
  }, []);

  useEffect(() => {
    gtmDataLayerAdapter.setUserProperty('locale', locale);
  }, [locale]);

  return null;
}

export function AnalyticsProvider(): React.JSX.Element | null {
  const ready = useIdleMount();
  if (!ready) {
    return null;
  }
  return <MountedAnalytics />;
}
